import React from 'react';
import { FormattedMessage } from 'react-intl';
import classes from './styles.module.css';

function Empty() {
    return (
        <div className={classes.Empty}>
            <span>
                <FormattedMessage id="TerminalsList.empty" defaultMessage="Ничего не найдено" />
            </span>
        </div>
    );
}

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/TerminalsList/Empty.js